<section class="master-admin-tile">
  <a  [class.disabled-widget]="!clickable" class="master-admin-tile-link" alt="Mojo For Suppliers Administration" (click)="onImgClick($event)">
    <img class="master-admin-tile-image" alt="Brand" src="assets/MasterAdminMFTTile.png"/>
  </a>
</section>
